import React, { useState } from "react";
import SharedHelmet from "../.././Helmet";
const TITLE = "تحويل العملات - محول العملات";
const DESCRIPTION = "استعرض جميع الحواسب المالية المتاحة للتحويل بين العملات.";
const KEYWORDS = "حواسب مالية, تحويل عملات, أدوات مالية, حاسبة تحويل عملات";
const OG_URL = "https://do-calculate.com/calculator/ar/currency_list/";
const currencyNames = {
  SAR: "ريال سعودي",
  AED: "درهم إماراتي",
  ANG: "غيلدر أنتيلي هولندي",
  AUD: "دولار أسترالي",
  BHD: "دينار بحريني",
  CAD: "دولار كندي",
  CHF: "فرنك سويسري",
  CNY: "يوان صيني",
  DZD: "دينار جزائري",
  EGP: "جنيه مصري",
  EUR: "يورو",
  GBP: "جنيه إسترليني",
  GIP: "جنيه جبل طارق",
  INR: "روبي هندي",
  IQD: "دينار عراقي",
  IRR: "ريال إيراني",
  ISK: "كرون آيسلندية",
  JOD: "دينار أردني",
  JPY: "ين ياباني",
  KMF: "فرنك جزر القمر",
  KWD: "دينار كويتي",
  LBP: "ليرة لبنانية",
  LYD: "دينار ليبي",
  MAD: "درهم مغربي",
  NZD: "دولار نيوزيلندي",
  OMR: "ريال عماني",
  QAR: "ريال قطري",
  RUB: "روبل روسي",
  SDG: "جنيه سوداني",
  SEK: "كرون سويدي",
  SGD: "دولار سنغافوري",
  SOS: "شلن صومالي",
  SSP: "جنيه جنوب سوداني",
  SYP: "ليرة سورية",
  TND: "دينار تونسي",
  TRY: "ليرة تركية",
  USD: "دولار أمريكي",
  YER: "ريال يمني",
};
const currencies = Object.keys(currencyNames);
function CurrencyList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = () => {
    let rowNumber = 1;
    return (
      <table >
        <thead>
          <tr>
            <th >الرقم</th>
            <th >من العملة</th>
            <th >إلى العملة</th>
            <th >رابط الحاسبة</th>
          </tr>
        </thead>
        <tbody>
          {currencies
            .filter((fromCurrency) =>
              currencyNames[fromCurrency].includes(searchTerm)
            )
            .map((fromCurrency) =>
              currencies
                .filter((toCurrency) =>
                  currencyNames[toCurrency].includes(searchTerm)
                )
                .map((toCurrency) => {
                  if (fromCurrency !== toCurrency) {
                    const url = `/calculator/ar/currency_converter/${fromCurrency}/${toCurrency}/`;
                    return (
                      <tr key={`${fromCurrency}-${toCurrency}`}>
                        <td>{rowNumber++}</td>                         <td>{currencyNames[fromCurrency]}</td>
                        <td>{currencyNames[toCurrency]}</td>
                        <td>
                          <a href={url}>
                            تحويل {currencyNames[fromCurrency]} إلى{" "}
                            {currencyNames[toCurrency]}
                          </a>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })
            )}
        </tbody>
      </table>
    );
  };
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>البحث عن العملة</h2>
          <input
            type="text"
            placeholder="ابحث عن عملة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable()}
        <br />
      </div>
    </div>
  );
}
export default CurrencyList;
